import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { AppTextService } from '@fi-shared/app-text';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { ISiteMap, ISiteMapContentItemViewModel } from '@fi-shared/models/site-map';
import { SiteMapHelperService } from '@fi-shared/fi-shared-services/site-map-helper.service';

@Component({
    selector: 'fi-site-map-view',
    templateUrl: './site-map-view.component.html',
    styleUrls: ['./site-map-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-site-map-view' },
    standalone: false,
})
export class SiteMapViewComponent implements OnInit {
    @Input() siteMap: ISiteMap;
    hasEditAccess: boolean;
    editTabs: EditTabsModel;
    moreMenuItems: MoreMenuMobileSettingsModel;
    siteMapViewData: ISiteMapContentItemViewModel[];

    constructor(
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private injector: Injector,
        private appTextService: AppTextService,
        private detectDevicesService: DetectDevicesService,
        private stateService: FiStateService,
        private siteMapHelperService: SiteMapHelperService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
        this.siteMapViewData = this.siteMapHelperService.getSiteMapContentItemViewData(
            this.siteMap.TagData.ChildItems,
            this.siteMap.TagData.Id,
        );
    }

    editSiteMap() {
        this.stateService.go(FiStateNames.SiteMap.Edit, { Id: this.siteMap.Id });
    }

    isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    private setPageHeaderData() {
        this.hasEditAccess =
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.Tag,
                AccessRightType.Admin,
            ) && this.siteMap.AccessRightFilterCollection.HasEditAccess;
        this.editTabs = new EditTabsModel(this.siteMap.Name, this.appTextService.get('back'));
        this.moreMenuItems = new MoreMenuMobileSettingsModel();

        if (this.hasEditAccess) {
            this.moreMenuItems.AddListItem(this.appTextService.get('common.edit'), () => this.editSiteMap());
        }
    }
}
